import { status } from 'skin/event/status';
import api from 'skin/http';
//Отправка заявки
export default function send(obj, form, story, data, d, action) {
	const config = {
		method: 'get',
		url: 'api/other/form/cmp_site/certbot'
	}
	api(config)
	.then(res => {
	})
	.catch(err => {
		const dt = err?.response?.data?.msg
		console.log('err', dt)
	})
	return status.ignore
}